import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

interface FeedbackRequest {
  message: string;
  currentUrl: string;
}

interface FeedbackResponse {
  success: boolean;
}

export const feedbackApiClient = createApi({
  reducerPath: 'feedbackApi',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<FeedbackResponse, FeedbackRequest>({
      query: (body) => ({
        url: 'api/feedback/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSubmitFeedbackMutation } = feedbackApiClient;
